export default ({ to, next, store, nextMiddleware }) => {

    if (to.meta.roles.includes(store.getters.getCurrentUserRole)) {
        return nextMiddleware()
    } else {
        return next({name: '403'})
    }
}
